import "./AboutContent&CVStyles.css"
import React from 'react'

function Publications() {

  return (
    <div className="about">    
      <div className="left">
        <h1>SOON</h1>
      </div>
  </div>
  )
}

export default Publications